module.exports = __webpack_public_path__ + "static/media/_united-states-of-america.936feee6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/_united-states-of-america.svg
// module id = 2360
// module chunks = 7